import { Component, inject, signal } from '@angular/core';
import { Location } from '@angular/common';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { BusinessAccountService } from '../../../../services/business-account/business-account.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-brand-products-rakuten',
  standalone: true,
  imports: [],
  templateUrl: './brand-products-rakuten.component.html',
  styleUrl: './brand-products-rakuten.component.css'
})
export class BrandProductsRakutenComponent {

  selectedTab = signal<'find' | 'list'>('find');

  private location = inject(Location);
  private currentUserService = inject(CurrentUserService);
  private businessAccountService = inject(BusinessAccountService);
  
  selectTabMobile(event: any) {
    console.log('selectTabMobile()', event);
    this.selectTab(event.target.value as 'find' | 'list');
  }

  selectTab(tab: 'find' | 'list') {
    this.selectedTab.set(tab);
    if (tab === 'find') {
      this.findRakutenProducts();
    } else if (tab === 'list') {
      this.listRakutenProducts();
    }
  }


  findRakutenProducts() {
    this.businessAccountService.findRakutenAdvertiserProducts(this.currentUserService.focussedBrand.id, {
      mid: this.currentUserService.focussedBrand.rakutenAdvertiserId,
    }).pipe(take(1)).subscribe((response) => {
      console.log('Rakuten products found:', response);
    });
  }

  listRakutenProducts() {
    console.log('List saved products that have a rakuten SKU....')
  }

  getTabClass(tab: 'find' | 'list') {
    return this.selectedTab() === tab ? 'bg-gray-200 text-gray-900 dark:bg-white/10 dark:text-gray-200' : 'text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200';
  }

  goBack() {
    this.location.back();
  }
}
